import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-integration-online-status',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './integration-online-status.component.html',
  styleUrl: './integration-online-status.component.scss',
})
export class IntegrationOnlineStatusComponent {
  @Input() isConnected = false;
  @Input() isOnline: boolean | null = null;
}
